import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    (variables: { questId: string }) => ({
      href: {
        params: { "quest-id": variables.questId },
        pathname: "/(nav)/(app)/learn/map/quest/[quest-id]",
      } as const,
      // Quests are bundled and their progress loads with the page, so there is nothing to prefetch.
      queries: [],
    }),
    [],
  );
}

/** Opens a quest's conversation over Learn's map. */
export const useQuestPageNavigator = createPageNavigator<{ questId: string }>({
  useNavigator,
});
